import { useMutation, UseMutationOptions } from 'react-query';

import { userApi } from 'src/Services/API';

export const useUpdateLastAssetTypeSelectionDate = (
  options?: UseMutationOptions<void, unknown, void>
) => {
  return useMutation<void, unknown, void>(
    ['update-last-asset-type-selection-date'],
    async () => {
      const response = await userApi.userControllerUpdateLastAssetTypeSelectionDate();
      return response.data;
    },
    options
  );
};

export default useUpdateLastAssetTypeSelectionDate;
